import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDynamicResolution } from "../../hooks";
import { Main } from "../Main/Main";
import { DocsSidebar } from "./components";
import { DocsLanguageProvider } from "./context";

const Docs = () => {
  const { t } = useTranslation();
  const isDesktop: boolean = useDynamicResolution();

  // YOSHI-10464: the provider wraps the whole portal, so the language chosen in one code block
  // holds for every other one: this layout stays mounted while the reader moves between pages.
  return (
    <DocsLanguageProvider>
      <Main isDesktop={isDesktop} t={t}>
        <section className="bg-white pt-32 px-[5%] sm:px-[3%] md:pt-40 pb-28 md:pb-40">
          <div className="w-full max-w-[80rem] mx-auto space-y-10">
            <div className="space-y-4">
              <h1 className="text-2xl/tight lg:text-3xl/tight font-bold">
                {t("docs.title")}
              </h1>
              <p className="text-base/relaxed lg:text-lg/relaxed text-gray-400">
                {t("docs.subtitle")}
              </p>
            </div>
            <div className="flex flex-col md:flex-row gap-8 md:gap-12">
              <DocsSidebar />
              {/* min-w-0 keeps a wide code block inside this column instead of stretching the row. */}
              <div className="min-w-0 flex-1">
                <Outlet />
              </div>
            </div>
          </div>
        </section>
      </Main>
    </DocsLanguageProvider>
  );
};

export default Docs;
